<template>
  <div>
    <div class="back">
        <el-button class="btn-back" @click.stop="onBack">返回</el-button>
    </div>
     <div class="module2Add_con detailsPage_con u-border">
      <!--表单项-->
      <div class="module2Add_form detailsPage_form">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="新闻标题:">
                {{form.title}}
            </el-form-item>
            <el-form-item label="新闻来源:">
                {{form.source}}
            </el-form-item>
            <el-form-item label="新闻排序:">
                {{form.indexing}} &nbsp;&nbsp;
                <span>
                    (排序值越大，排名越靠前)
                </span>
            </el-form-item>
            <el-form-item label="发布时间:">
                {{form.gen_time}}
            </el-form-item>
            <el-form-item label="新闻状态:">
                {{form.status}}
            </el-form-item>
            <el-form-item label="新闻简介:">
                {{form.introduce}}
            </el-form-item>
            <el-form-item label="新闻内容:">
                {{form.content}}
            </el-form-item>
            <el-form-item label="新闻封面:">
                <el-image
                style="width: 200px; height: 200px"
                :src="form.cover_image">
                </el-image>
            </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
    import { getNewsDetail } from '@/api/apii';
    export default {
        name: 'newsDetail',
        inject: ['myMessage', 'reload'],
        data () {
            return {
                form: {
                    title: '',
                    source: '',
                    indexing: 0,
                    status: 0,
                    introduce: '',
                    content: '',
                    desc: '',
                    time: '',
                    cover_image: ''
                },
                id: ''
            };
        },
        methods: {
            requestData () {
                let id = this.$route.params.id;
                getNewsDetail(id)
                .then((res) => {
                    this.handleDetailsData(res.data);
                })
                .catch(() => {
                    this.myMessage.megError('获取详情信息失败');
                });
            },
            handleDetailsData (data) {
                this.form = { ...data };
                this.form.status = this.form.status === 0 ? '隐藏' : '显示';
                console.log(this.form);
            },
            onBack () {
                this.$router.back();
            }
        },
        created () {
            this.requestData();
        }
    };
</script>

<style>
    .back {
        position: relative;
    }
    .btn-back {
        position: absolute;
        top:30px;
        right: 40px;
    }
</style>
